import { render, staticRenderFns } from "./PassChangePage.vue?vue&type=template&id=674c28f8"
import script from "./PassChangePage.vue?vue&type=script&lang=js"
export * from "./PassChangePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports